import { jsxs as x, Fragment as l, jsx as i } from "react/jsx-runtime";
import D, { useEffect as Y } from "react";
import { useI18n as q } from "next-localization";
import { c as r } from "./clsx.OuTLNxxd.js";
import { u as z } from "./use-get-is-facility-open.Cngix8AG.js";
import { OperatingStatusCodes as S } from "../types/search/index.js";
import { locationHasHours as Q } from "../utils/locations/index.js";
import { formatTime as E } from "../utils/date-time/index.js";
import { L as V } from "./link-button.z9udOW1b.js";
const X = [
  { day: 1, label: "Mon: " },
  { day: 2, label: "Tue: " },
  { day: 3, label: "Wed: " },
  { day: 4, label: "Thur: " },
  { day: 5, label: "Fri: " },
  { day: 6, label: "Sat: " },
  { day: 0, label: "Sun: " }
], oc = ({
  heading: j,
  result: c,
  titleClassName: d,
  dropdownClassNames: e,
  fontClassName: n,
  mobileDayWidthClass: k = "w-20",
  hoursButtonClassName: A
}) => {
  var u, v, F, I;
  const { t: o } = q(), P = o("Locations.Card.Hours"), a = o("Locations.Card.Am"), p = o("Locations.Card.Pm"), L = o("Locations.Card.Closed"), b = c == null ? void 0 : c.marketedFacilityHours, R = (u = c == null ? void 0 : c.currentOperatingHours) == null ? void 0 : u.open, W = (v = c == null ? void 0 : c.currentOperatingHours) == null ? void 0 : v.close, { isFacilityCurrentlyOpen: Z, isOpen24Hours: _ } = z(R, W, c), [h, B] = D.useState();
  Y(() => {
    const H = (/* @__PURE__ */ new Date()).getDay();
    B(H);
  }, []);
  const f = new RegExp(
    (c == null ? void 0 : c.operatingStatusCodeOverride) ?? (c == null ? void 0 : c.operatingStatusCode) ?? "",
    "i"
  ), [g, G] = D.useState(!1);
  if (!b || !Q(c)) return;
  const J = /* @__PURE__ */ x(l, { children: [
    /* @__PURE__ */ i(
      "p",
      {
        className: r(d, {
          "neu-text-body": !n,
          [n || ""]: n,
          "mb-1": !(d != null && d.includes("mb-"))
        }),
        children: j || P
      }
    ),
    (c == null ? void 0 : c.hoursNote) && /* @__PURE__ */ i(
      "p",
      {
        className: r("mb-1", {
          "neu-text-body": !n,
          [n || ""]: n
        }),
        children: c.hoursNote
      }
    )
  ] }), O = /* @__PURE__ */ i(
    "span",
    {
      className: r("neu-text-green-60 fw-bold", {
        "neu-text-body": !n,
        [n || ""]: n
      }),
      children: o("Locations.Card.Open")
    }
  ), T = /* @__PURE__ */ i(
    "span",
    {
      className: r("neu-text-red-60 fw-bold", {
        "neu-text-body": !n,
        [n || ""]: n
      }),
      children: L
    }
  );
  let y;
  if (_)
    y = /* @__PURE__ */ x("div", { children: [
      O,
      /* @__PURE__ */ i("span", { children: ` ${o("Locations.Card.24Hours")}` })
    ] });
  else if (S.ClosedPermanent.match(f))
    y = /* @__PURE__ */ i("div", { children: T });
  else if (S.ClosedTemporary.match(f))
    y = /* @__PURE__ */ i("span", { className: r("neu-text-red-60 fw-bold"), children: o("Locations.Card.TempClosed") });
  else if (S.Planned.match(f))
    y = /* @__PURE__ */ i("span", { className: r("neu-text-red-60 fw-bold"), children: o("Locations.Card.ComingSoon") });
  else {
    const H = (m, M) => {
      var $;
      const t = b == null ? void 0 : b[m], U = t != null && t.open && (t != null && t.close) ? `${E(t == null ? void 0 : t.open, a, p)}-${E(t == null ? void 0 : t.close, a, p)} ${($ = c == null ? void 0 : c.timeZone) == null ? void 0 : $.replace(/[^A-Z]/g, "")}` : L;
      return /* @__PURE__ */ x(
        "div",
        {
          className: r(
            "d-flex mx-0",
            (e == null ? void 0 : e.menuJustifyClass) || "justify-content-lg-between",
            {
              "my-2": !(e != null && e.menuItem),
              [(e == null ? void 0 : e.menuItem) || n || ""]: (e == null ? void 0 : e.menuItem) || n
            }
          ),
          children: [
            /* @__PURE__ */ i(
              "span",
              {
                className: r("me-1", k, {
                  "fw-bold": m === h
                }),
                children: M
              }
            ),
            /* @__PURE__ */ i(
              "span",
              {
                className: r({
                  "fw-bold": m === h
                }),
                children: U
              }
            )
          ]
        }
      );
    }, K = Z ? /* @__PURE__ */ x("div", { children: [
      O,
      h !== void 0 && /* @__PURE__ */ i("span", { children: ` ${o("Common.Until")} ${(I = E((F = b == null ? void 0 : b[h]) == null ? void 0 : F.close, a, p)) == null ? void 0 : I.toString()}` })
    ] }) : T;
    y = /* @__PURE__ */ x(l, { children: [
      K,
      /* @__PURE__ */ x("div", { children: [
        /* @__PURE__ */ i(
          V,
          {
            className: r(A, "ps-0"),
            onClick: () => G(!g),
            children: o(g ? "Locations.Card.CollapseHoursSection" : "Locations.Card.ExpandHoursSection")
          }
        ),
        g && /* @__PURE__ */ i("div", { className: "my-3", children: X.map((m) => H(m.day, m.label)).filter((m) => m !== null) })
      ] })
    ] });
  }
  return /* @__PURE__ */ x("div", { className: "col-12", children: [
    J,
    /* @__PURE__ */ i(
      "div",
      {
        className: r({
          [(e == null ? void 0 : e.menu) || n || ""]: (e == null ? void 0 : e.menu) || n
        }),
        children: y
      }
    )
  ] });
};
export {
  oc as O
};
